var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('leaflet-map-catalogs-button',{on:{"activated":_vm.onActivated}}),_c('leaflet-map-background-layers-button',{on:{"activated":_vm.onActivated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }